<template>
  <CustomPage title="我的钱包" :noBorder="true" style="background: #f7f7f7">
    <div slot="content">
      <div class="wallet-container">
        <div class="head">
          <div class="label">当前钱包余额(元)</div>
          <div class="value">{{ withdrawAmount }}</div>
        </div>
        <div class="box">
          <div class="menu">
            <div
              class="cell van-hairline--bottom"
              v-for="item in menu"
              :key="item.label"
              @click="cellClick(item.router)"
            >
              <div class="label">
                <img :src="item.icon" alt="" />
                <span>{{ item.label }}</span>
              </div>
              <div class="value">
                <img :src="require('@/assets/setting/箭头.svg')" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { getWallet } from "@/api/wallet";
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
export default {
  components: { CustomPage, CustomView },
  data() {
    return {
      withdrawAmount: null,
      menu: [
        {
          icon: require("@/assets/mine/提现.svg"),
          label: "提现",
          router: "WalletWithdraw",
        },
        {
          icon: require("@/assets/mine/账户明细.svg"),
          label: "账户明细",
          router: "WalletAccountDetail",
        },
        {
          icon: require("@/assets/mine/提现记录.svg"),
          label: "提现记录",
          router: "WalletRecord",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    if(to.name === "Wallet") {
      this.getData();
    }
    next();
  },
  methods: {
    getData() {
      const customerId = this.$store.state.user.customerId;
      getWallet(customerId).then((res) => {
        this.withdrawAmount = res.data.withdrawAmount;
      });
    },
    cellClick(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="less" scoped>
.wallet-container {
  .head {
    padding: 10px 52px 42px;
    color: #fff;
    background-color: #c82d26;
    .label {
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
    }
    .value {
      margin-top: 32px;
      font-size: 80px;
      font-weight: 800;
      line-height: 80px;
      height: 80px;
    }
  }
  .box {
    padding: 24px;
    .menu {
      background-color: #fff;
      border-radius: 12px;
      .cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 28px;
        padding: 20px 20px 18px 28px;
        &::after {
          border-color: #f2f2f2;
        }
        img {
          display: inline-block;
        }
        .label {
          display: flex;
          align-items: center;
          img {
            width: 48px;
            height: 48px;
            margin-right: 24px;
          }
        }
        .value {
          img {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
  }
}
</style>